import { useTranslation } from 'react-i18next';
import { CheckboxBlockField } from 'components';
import { SetupCheckboxItemContainer } from '../../components/SetupCheckboxItemContainer';

export const GroupMeetingSection = () => {
  const { t } = useTranslation();
  return (
    <SetupCheckboxItemContainer>
      <CheckboxBlockField
        label={t('studySetup.generalSetup.groupMeeting.individual')}
        type="radio"
        variant="green"
        name="groupMeeting"
        value={false}
        icon="ri-user-3-line"
        trackingName="Focus Group"
      />
      <CheckboxBlockField
        label={t('studySetup.generalSetup.groupMeeting.group')}
        type="radio"
        variant="green"
        name="groupMeeting"
        value={true}
        icon="ri-team-line"
        trackingName="Focus Group"
      />
    </SetupCheckboxItemContainer>
  );
};
